import React from "react";

// pages
import Dashboard from "pages/dashboard/DashboardNew";

import ContractorBusinessProfile from "pages/profile/ContractorProfile";
// import { loadUserDetails } from "actions/login_registrationActions";
import CompaniesList from "pages/companies/CompaniesList";
import Projects from "pages/projects/Projects";
import AddNewProperty from "pages/property/AddNewProperty";
import Jobs from "pages/job/Jobs";
import PurchaseOrders from "pages/orders/PurchaseOrders";
import Invoice from "pages/invoice/Invoice";
import Payments from "pages/orders/Payments";
// import Tasks from "pages/task/Tasks";
import GanttChart from "pages/GanttChart/GanttChart";
// import Reports from "pages/reportdefinition/Reports";
// import MyReports from "pages/reportdefinition/MyReports";
import ReportDetails from "pages/reportdefinition/ReportDetails";
import ViewReport from "pages/reportdefinition/ViewReport.js";
import ReportColumnDetails from "pages/reportdefinition/ReportColumnDetails.js";
import {
  ViewJob,
  ViewProject,
  ViewTask,
  Timesheet,
  UsersList,
  UnderDevelopment,
  Connections,
  AdminDashboard,
  ViewProperty,
} from "./loadables";
import { Navigate } from "react-router-dom";
import Estimations from "pages/estimations/EstimatesList";
import ReportWrapper from "pages/reportdefinition/ReportWrapper";
import {
  hasSubscription,
  roleConstants as roles,
  appRoles,
  rolesConfig,
  subscriptionConstants as plans,
} from "core/utils/roleUtils";
import SSORegistration from "pages/login/sso_registration/SSO_RegistrationPage";
import { new_routes } from "./new_routes";
import PropertiesFolderView from "pages/property/PropertiesFolderView";
import Settings from "pages/settings/Settings";
import FileManager from "pages/file_manager/FileManager";
import EstimateTemplate from "pages/estimations/EstimateTemplate";

export const externalRoutes = [
  {
    path: "/profile/contractor/businessProfile",
    component: <ContractorBusinessProfile />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
  },
  {
    path: "/sso-login/new-registration",
    component: <SSORegistration />,
  },
];

const builderRoutes = [
  {
    path: "/builder/purchaseOrders",
    component: <PurchaseOrders />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/builder/invoiceOrders",
    component: <Invoice />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/builder/payments",
    component: <Payments />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },

  {
    path: "/builder/estimations",
    component: <Estimations />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/builder/estimations/:estimateId",
    component: <EstimateTemplate />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/builder/connections",
    component: <Connections type={"builder"} />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
];

export const supplierAdminRoutes = [
  {
    path: "/supplier/connections",
    component: <Connections type={"supplier"} />,
    roles: [roles.SUPPLIER_ADMIN, roles.SUPPLIER_GENERAL_MANAGER],
  },
];

export const routePaths = [
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "/", component: <Navigate to="/dashboard" /> },
  {
    path: "/dashboard",
    component: <Dashboard />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
    fallBack: "/properties",
  },
  {
    path: "/admin/dashboard",
    component: <AdminDashboard />,
    roles: roles.SYSTEM_ADMIN,
  },

  {
    key: "homeOwnerAddProperty",
    path: "/profile/homeOwner/addProperty",
    component: <AddNewProperty />,
    callback: (navigate) => () => {
      navigate("/");
    },
  },
  {
    path: "/companies",
    component: <CompaniesList />,
    // roles: [roles.HOME_OWNER, roles.SYSTEM_ADMIN],
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/buildersSearch",
    component: <CompaniesList />,
    roles: [roles.HOME_OWNER],
  },
  {
    path: "/properties",
    component: <PropertiesFolderView />,
    // roles: [
    //   roles.BUILDER_ADMIN,
    //   roles.BUILDER_GENERAL_MANAGER,
    //   roles.BUILDER_PROJECT_MANAGER,
    // ],
  },
  {
    path: "/properties/view/:propertyId",
    component: <ViewProperty />,
    roles: [...rolesConfig.adminRoles, ...rolesConfig.propertyViewRole],
  },

  {
    path: "/projects",
    component: <Projects />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.BUILDER_TEAM_MEMBER,
      roles.BUILDER_PROJECT_MANAGER,
      roles.BUILDER_JOB_MANAGER,
      roles.BUILDER_PROJECT_MEMBER,
    ],
  },
  {
    path: "/projects/view/:projectId",
    component: <ViewProject key="project-only-view" />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      ...rolesConfig.projectViewRole,
    ],
  },
  {
    path: "/jobs",
    component: <Jobs />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.BUILDER_TEAM_MEMBER,
      roles.BUILDER_PROJECT_MEMBER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
      roles.SUPPLIER_PROJECT_MANAGER,
      roles.SUPPLIER_JOB_MANAGER,
      roles.SUPPLIER_TEAM_MEMBER,
    ],
  },
  {
    path: "/jobs/view/:jobId",
    component: <ViewJob />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  // {
  // 	path: "/tasks",
  // 	component: <Tasks />,
  // },
  {
    path: "/tasks/view/:taskId",
    component: <ViewTask />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/project/:projectId/tasks/:taskId",
    component: <ViewTask />,
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/purchaseOrders",
    component: <PurchaseOrders />,
    roles: rolesConfig.adminRoles,
  },
  {
    path: "/invoiceOrders",
    component: <Invoice />,
    roles: rolesConfig.adminRoles,
  },
  {
    path: "/payments",
    component: <Payments />,
    roles: rolesConfig.adminRoles,
  },
  {
    path: "/timelines",
    component: <GanttChart />,
    roles: [roles.BUILDER_ADMIN, roles.BUILDER_GENERAL_MANAGER],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/timesheet",
    component: <Timesheet />,
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/users",
    component: <UsersList />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    // shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/estimations",
    component: <Estimations />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/estimations/:estimateId",
    component: <EstimateTemplate />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  { path: "/page/underDevelopment", component: <UnderDevelopment /> },
  {
    path: "/reports",
    component: <ReportWrapper type="myReports" />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/createreport/:id?",
    component: <ReportDetails />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/viewreport/:id",
    component: <ViewReport />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/reportcolumn/:id?/:reportid?",
    component: <ReportColumnDetails />,
    roles: [
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
      roles.SUPPLIER_ADMIN,
      roles.SUPPLIER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/settings",
    component: <Settings />,
    roles: [roles.SYSTEM_ADMIN, ...appRoles.builderAdmin],
  },
  {
    path: "/filemanager/:propertyId?/:projectId?/:jobId?",
    component: <FileManager />,
    roles: [
      roles.SYSTEM_ADMIN,
      roles.BUILDER_ADMIN,
      roles.BUILDER_GENERAL_MANAGER,
    ],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },
  {
    path: "/settings/companies/view/:companyId",
    component: <ViewJob />,
    roles: [roles.SYSTEM_ADMIN],
    shouldHide: (profile) => hasSubscription(profile, plans.FREE_SUBSCRIPTION),
  },

  ...builderRoutes,
  ...supplierAdminRoutes,
  ...new_routes,
];

export default routePaths;
